
/* === CUSTOM LBA JS === */

/* --- MARQUEE ANNOUNCEMENT BAR --- */
document.addEventListener('DOMContentLoaded', function() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  // Find the text content
  const msgEl = bar.querySelector('.announcement-bar__message');
  if (!msgEl) return;
  const text = msgEl.textContent.trim();
  if (!text) return;

  // Find the container to replace content in
  const container = msgEl.closest('.announcement-bar__message') || msgEl;
  
  // Create marquee wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'marquee-wrapper';
  
  const content = document.createElement('div');
  content.className = 'marquee-content';
  
  // Duplicate text multiple times for seamless loop
  for (let i = 0; i < 6; i++) {
    const span = document.createElement('span');
    span.textContent = text;
    content.appendChild(span);
  }
  
  wrapper.appendChild(content);
  
  // Replace the original message
  const parent = container.parentElement;
  parent.innerHTML = '';
  parent.appendChild(wrapper);
});

/* --- VIDEO AUTOPLAY ON SCROLL --- */
document.addEventListener('DOMContentLoaded', function() {
  const videoSections = document.querySelectorAll('.video-section, [class*="video"]');
  
  videoSections.forEach(function(section) {
    const deferredMedia = section.querySelector('deferred-media');
    if (!deferredMedia) return;
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !deferredMedia.hasAttribute('loaded')) {
          const playBtn = deferredMedia.querySelector('.deferred-media__poster-button, button');
          if (playBtn) {
            playBtn.click();
            setTimeout(function() {
              const video = deferredMedia.querySelector('video');
              if (video) {
                video.muted = true;
                video.loop = true;
                video.playsInline = true;
                video.autoplay = true;
                video.play().catch(function() {});
              }
            }, 500);
          }
        }
      });
    }, { threshold: 0.3 });
    
    observer.observe(section);
  });
});
